import { FilterTypes } from 'Core/interfaces'

import { UrlParams } from 'Portals/Supplier/constants'
import { Document, DocumentFilterFields } from 'Portals/Supplier/entities'
import i18n from 'Portals/Supplier/utils/i18nService'

export const getFilterConfig = (): Document.Filter.Config => ({
	[DocumentFilterFields.documentTypeIds]: {
		label: i18n.t('pages:documents.filters.documentType'),
		apiFilterFieldName: DocumentFilterFields.documentTypeIds,
		filterType: FilterTypes.MULTI_VALUE,
		UrlParam: UrlParams.documentTypeId,
		defaultValue: ['']
	},
	[DocumentFilterFields.supplierLocationId]: {
		label: i18n.t('pages:documents.filters.supplierLocation'),
		apiFilterFieldName: DocumentFilterFields.supplierLocationId,
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.supplierLocationId,
		defaultValue: ''
	},
	[DocumentFilterFields.statusId]: {
		label: i18n.t('pages:documents.filters.status'),
		apiFilterFieldName: DocumentFilterFields.statusId,
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.status,
		defaultValue: ''
	},
	[DocumentFilterFields.showOnlySupplierDocuments]: {
		label: i18n.t('pages:documents.filters.showOnly'),
		apiFilterFieldName: DocumentFilterFields.showOnlySupplierDocuments,
		filterType: FilterTypes.BOOLEAN,
		UrlParam: UrlParams.showOnlySupplierDocuments,
		defaultValue: false
	}
})
